import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import VueGtm from 'vue-gtm';
import VueGtag from "vue-gtag";

import {GTM_CODE,NODE_ENV} from './env'

import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueSSE from 'vue-sse';
import Storage from 'vue-web-storage';
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(VueSSE);
Vue.mixin({
  created: function () {
    // Esto se ejecuta cada vez que se crea un componente
  }
});

// Configuration VueAnalytics

Vue.use(VueGtag, {
  config: { id: "UA-90608419-1" },
  bootstrap: NODE_ENV === 'production',
  params: {
    send_page_view: false
  }
},router);

Vue.use(VueGtm, {
  id: GTM_CODE, // Your GTM ID
  enabled: NODE_ENV === 'production', // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: NODE_ENV !== 'production', // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});
Vue.use(Storage, {
  prefix: 'oniad_academy.',// default `app_`
  drivers: ['session'], // default 'local'
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
